import React from "react";
import styles from "./Row.module.sass";
import cn from "classnames";
import { useNavigate } from "react-router-dom";
import Icon from "../../../../components/Icon";
import Control from "./Control";

const Row = ({ item, onClick }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;

      return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(date);
    } catch (e) {
      return dateString;
    }
  };

  const calculateProgress = () => {
    const totalSteps = 4;
    let completedSteps = 0;
    const progressData = item.progression?.entreprise;

    if (progressData) {
      if (progressData.infos_remplies) completedSteps++;
      if (progressData.contrat_cree) completedSteps++;
      if (progressData.tuteur_assigne) completedSteps++;
      if (progressData.sign) completedSteps++;
    }

    const progressPercent = (completedSteps / totalSteps) * 100;
    const isComplete = completedSteps === totalSteps;

    return { completedSteps, totalSteps, progressPercent, isComplete };
  };

  const getNextStep = () => {
    const progressData = item?.progression?.entreprise;
    const studentData = item?.progression?.etudiant;

    // Si l'étudiant n'a pas rempli ses infos, pas d'accès
    if (!studentData?.infos_remplies) {
      return null;
    }

    if (!progressData) return 1;
    if (!progressData.infos_remplies) return 1;
    if (!progressData.contrat_cree) return 2;
    if (!progressData.tuteur_assigne) return 3;
    if (!progressData.valide) return 4;

    return 'completed';
  };

  const handleRowClick = () => {
    if (onClick) {
      onClick(item.id);
    }

    const nextStep = getNextStep();
    
    if (nextStep === null) {
      return; // En attente de l'élève
    }
    
    if (nextStep === 'completed') {
      navigate(`/company/folder/${item.id}/view`);
      return;
    }
    
    if (nextStep === 4) {
      navigate(`/company/folder/${item.id}/validation`);
      return;
    }
    
    navigate(`/company/folder/${item.id}/${nextStep}`);
  };

  const handleRowContentClick = (e) => {
    if (!e.target.closest('button') && !e.target.closest(`.${styles.control}`)) {
      handleRowClick(e);
    }
  };

  const getStatus = () => {
    const studentData = item?.progression?.etudiant;
    const progressData = item?.progression?.entreprise;
    
    // Si l'élève n'a pas rempli ses infos
    if (!studentData?.infos_remplies) {
      return { label: "En attente élève", color: "status-yellow" };
    }
    
    // Si tout est terminé
    if (progressData?.sign) {
      return { label: "Terminé", color: "status-green" };
    }
    
    // Si l'entreprise travaille dessus
    return { label: "En cours", color: "status-blue" };
  };

  const student = item.expand?.student_id;
  const progress = calculateProgress();
  const progressColor = progress.isComplete ? "#10B981" : "#78C4D1";
  const status = getStatus();

  return (
    <>
      <div className={styles.row} onClick={handleRowContentClick} style={{ cursor: 'pointer' }}>
        <div className={styles.col}>
          <div className={styles.item}>
            <div className={styles.avatar}>
              <img src="/images/content/contract_logo.png" alt="Contrat" />
            </div>
            <div className={styles.details}>
              <div className={styles.user}>
                {student ? `${student.first_name || ''} ${student.last_name || ''}` : 'Non défini'}
              </div>
              <div className={styles.login}>Contrat d'apprentissage</div>
            </div>
          </div>
        </div>

        <div className={styles.col}>
          <div className={styles.folderId}>{item.id || 'N/A'}</div>
        </div>

        <div className={styles.col}>
          <div className={styles.date}>{formatDate(item.created)}</div>
        </div>

        <div className={styles.col}>
          <div className={styles.progressContainer}>
            <div 
              className={styles.progressNumber}
              style={{ color: progressColor }}
            >
              {progress.completedSteps}/{progress.totalSteps}
            </div>
            <div className={styles.progressLine}>
              <div
                className={styles.progressBar}
                style={{
                  backgroundColor: progressColor,
                  width: `${progress.progressPercent}%`,
                }}
              />
            </div>
          </div>
        </div>

        <div className={styles.col}>
          <div className={cn('status-type', status.color)}>
            {status.label}
          </div>
        </div>

        <div className={styles.col}>
          <Control className={styles.control} item={item} />
        </div>
      </div>
    </>
  );
};

export default Row;
